module.exports = __webpack_public_path__ + "static/media/maintenance.f66ee904.jpg";